import { CART, SET_ID } from "./cartActionsTypes";

export const setCartId = (id: string | null, eventId: string) => ({
    altType: CART,
    type: SET_ID,
    id,
    eventId,
});

